// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"c290a206","488":"64095c3a"}[chunkId] + ".chunk.js";
};